// Types
import { ERoute } from '~/modules/dashboard/types';

const MANAGER_PATH: string = 'manager';

const ADMIN_PATH: string = 'admin';

const HOMESEARCH_RECONTACT_URL: string = 'https://homesearch.co.uk/recontact/';

const LOGO_SUBTITLE: string = 'Convert your contacts into instructions';

const DEFAULT_ROUTE_NAME: string = ERoute.ON_MARKET;

export { MANAGER_PATH, ADMIN_PATH, HOMESEARCH_RECONTACT_URL, LOGO_SUBTITLE, DEFAULT_ROUTE_NAME };
